import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Avatar, CircularProgress, Grid, Paper, MenuItem, Card, Typography, TextField , Chip } from "@mui/material";
import MyTable from "../../components/Schedule/MyTable";
import Modal from 'react-bootstrap/Modal';
import ApiService from "../../functions/apiService";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import { formateDate } from "../../utils/helperFunctions";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { toast } from "react-toastify";

const Swaplist = () => {
	const [saving, setSaving] = useState(false);
	const [allowedVars, setAllowedVars] = useState({})
	const [dailySwapListData , setDailySwapListData] = useState([]);
	const [selectedSwapData , setSelectedSwapData] = useState([]);
	const [show , setShow] = useState(false);
	const [swapReason, setSwapReason] = useState('');

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
				setAllowedVars(res?.data?.data)
			}).catch(({ error }) => {
				console.log('error', error)
			});
	}

	useEffect(()=>{
		getAllowedVars()
	} , [])

	const columns2 = [
		{
			field: "Shift_Date",
			headerName: "Date",
			flex: 1,
			valueGetter: (params) =>
				moment(params.row.Shift_Date).format('MM/DD/YYYY')
		},
		{
			field: "Shift_Number",
			headerName: "Shift Number",
			flex: 1,
		},
		{
			field: "Absent_Code",
			headerName: "Absent Code",
			flex: 1,
		},
		{
			field: 'Shift_Code',
			headerName: 'Shift',
			width:220,
			renderCell: (params) => {
				const status = params.value;
				return <Chip
					sx={{
						height: 'auto',
						'& .MuiChip-label': {
							display: 'block',
							whiteSpace: 'normal',
						},
					}}
					style={{
						textAlign: 'center',
						padding: '6px 0px',
						width: '60%',
						color: '#2E3238',
						backgroundColor: status === 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
						border: status === 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
					}}
					label={status === 2 ? 'Day' : status === 91 ? `Custom` : 'Night'}
				/>;
			},
		},
		{
			field: "Request_By",
			headerName: "Request By",
			flex: 1,
		},
		{
			field: "Request_To",
			headerName: "Request To",
			flex: 1,
		},
		{
			field: "actions",
			headerName: "Actions",
			flex: 1,
			minWidth: 120,
			maxWidth: 150,
			renderCell: (params) => {
				return (
					<>
						<Button
							variant="contained"
							onClick={() => {
								setShow(true)
								setSelectedSwapData(params?.row)
							}}
							sx={{
								backgroundColor: '#ff0000',
								color:'#ffffff',
								marginLeft:'10px',
								padding : '8px',
								boxShadow:'none',
							}}
						>	{'Cancel Swap'}
						</Button>
					</>
				);
			},
		}
	];

	const dailySwapList = (row) => {
		setSaving(true);
		ApiService.get(`/adminSwapListDaily`)
			.then((data) => {
				setSaving(false);
				const responseData = data?.data?.data || {};
				const arrayData = Object.entries(responseData).map(([key, value]) => ({
						id: key,
						...value,
				}));
				setDailySwapListData(arrayData);
			})
			.catch((error) => {
				setSaving(false);
				toast.error(error.response.data.message, { variant: "error" });
			});
	};

	useEffect(()=>{
		dailySwapList();
	} , [])

	const handleDailySwapCancel = (row) => {
		setSaving(true);
		ApiService.post("/adminSwapDailyCancel", {
			"Shift_Number": row?.Shift_Number,
			"Shift_Date": row?.Shift_Date,
			"Shift_Code": row?.Shift_Code,
			"Emp_Code": row?.Orig_Emp_Code,
			"Swap_Emp_Code": row?.Emp_Code,
			"Comment" : swapReason
		})
			.then((data) => {
				setSaving(false);
				setSwapReason('');
				setShow(false);
				toast.success(data?.log_msg)
				dailySwapList();
			})
			.catch((error) => {
				setSaving(false);
				toast.error(error?.data?.message)
			});
	};

	return (
		<>
			<ManagementHeaderNav />
			<Paper className="p-3" style={{ marginTop: '1rem', maxWidth: '93vw', overflowX: 'auto', }}>
				<Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
					<Grid item xs={12}>
						<div style={{ display: 'flex', justifyContent: 'space-between', height: '40px' }}>
							<Typography variant="h6">Daily Swap list</Typography>
						</div>
						<div>

							{saving && (
								<Box className="w-100 d-flex justify-content-center align-items-center mt-2"
									style={{ height: '510px' }}>
									<CircularProgress />
								</Box>
							)}

							<>
							{!saving &&
								<Box
									sx={{
										maxWidth: "93vw",
										overflowX: "auto",
										background: "#FFF",
										marginTop: "1rem",
									}}
								>
									{dailySwapListData.length > 0 &&
										<div className="hide-header-checkbox-page">
											<MyTable
												rows={dailySwapListData}
												columns={columns2}
												useTopFilter={false}
												hideFooter={true}
												checkboxSelection={false}
											/>
										</div>}
									{dailySwapListData.length == 0 &&
										<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
											<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
											<span className='mt-4' style={{ color: '#555555' }}>
												No Shifts Found
											</span>
										</div>
									}
								</Box>
							}
							</>

						</div>
					</Grid>
				</Grid>
			</Paper >


			<Modal show={show} onHide={() => { 
					setShow(false)
					setSwapReason('')
				}}>
				<Modal.Header closeButton>
					<Modal.Title>Cancel Swap</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' , width: '80%'}}>
						Are you sure to cancel this swap ?
					</div>
					<Row className="mt-3">
						<Col md={12}>
							<label className="mb-1">Reason</label>
							<TextField
								fullWidth
								multiline
								rows={2}
								variant="outlined"
								placeholder="Reason"
								value={swapReason}
								onChange={(e) => setSwapReason(e.target.value)}
							/>
						</Col>
					</Row>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' 
								onClick={() => { 
									setShow(false)
									setSwapReason('')
								}}
							>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => handleDailySwapCancel(selectedSwapData)}>
								Submit
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

		</>
	);
};

export default Swaplist;
